import axios from '../utils/axios';

export default function uploadNTCPremiumJobsCsv(adminId, file) {
    return axios.post(`/admin/${adminId}/ntc-premium-jobs/upload`, file)
        .then(res => res.data)
        .catch(err => err);
}
